import { Directive, input } from '@angular/core';
import { LookupResponse } from '@core/models/common.model';
import { Lookups, lookupDescription, lookupItems, lookupName } from '@core/lookup/lookup-utils';

// What every step of the intake form has: the reference lists and whether the form can be changed.
@Directive()
export abstract class CiaStepBase {
  readonly lookups = input<Lookups>({});
  readonly readOnly = input(false);

  protected options(key: string): LookupResponse[] {
    return lookupItems(this.lookups(), key);
  }

  protected lookupName(key: string, id: unknown): string {
    return lookupName(this.lookups(), key, id);
  }

  protected lookupDescription(key: string, id: unknown): string {
    return lookupDescription(this.lookups(), key, id);
  }
}
